import { Organisation, EntityTypeEnum, User, FilterOperation, SubscriptionFilter, TradingEntity } from 'api'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { createAllEntitiesSortedSelector } from 'selectors/entitySelectors'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'
import { compareInsensitive } from 'utils'
import { ComboboxField } from 'view/components/options'
import {
  getBuyOrSellSideUsernames,
  getOrganisationIdFromTradingEntityIdsString,
  getSubscriptionFilterValue,
  getUsernamesBelongingToOrganisation,
  getUsernamesBelongingToTradingEntity
} from '../utils'

interface CounterpartyTraderSubscriptionComboboxProps {
  subscriptionFilters: SubscriptionFilter[]
  handleUpdateFilterValue: (fieldName: string, filterOperation: FilterOperation) => (value: any) => void
}

export const CounterpartyTraderSubscriptionCombobox: React.FC<CounterpartyTraderSubscriptionComboboxProps> = ({
  subscriptionFilters,
  handleUpdateFilterValue
}) => {
  const isAdmin = useSelector(isAdminGatewayUserSelector)
  const allOrganisations: Organisation[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.ORGANISATION))
  const allUsers: User[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.USER))
  const allTradingEntities: TradingEntity[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.TRADING_ENTITY))
  const allSortedUsers = allUsers.sort((u1, u2) => compareInsensitive(u1.username, u2.username))

  const counterpartyFirmSubscriptionFilterValue = getOrganisationIdFromTradingEntityIdsString(
    allTradingEntities,
    getSubscriptionFilterValue(subscriptionFilters, 'counterpartyId', FilterOperation.CONTAINS)
  )
  const counterpartySubscriptionFilterValue = getSubscriptionFilterValue(subscriptionFilters, 'counterpartyId', FilterOperation.EQUALS)
  const filteredUsernames = counterpartyFirmSubscriptionFilterValue
    ? getUsernamesBelongingToOrganisation(allSortedUsers, counterpartyFirmSubscriptionFilterValue)
    : getUsernamesBelongingToTradingEntity(allSortedUsers, counterpartySubscriptionFilterValue)
  const nonFilteredUsernames = getBuyOrSellSideUsernames(allSortedUsers, allOrganisations, false)
  const usernames =
    counterpartyFirmSubscriptionFilterValue || counterpartySubscriptionFilterValue ? filteredUsernames : nonFilteredUsernames

  return (
    <ComboboxField
      label={Locale.translate(Translation.SC_FILTER_COUNTERPARTY_TRADER_EQUALS)}
      dataTestId={'AdvancedDealSubscriptionFilters-Selectbox-CounterpartyTrader'}
      canClear={true}
      optionKeys={usernames}
      value={isAdmin ? getSubscriptionFilterValue(subscriptionFilters, 'counterpartyTraderId') : null}
      onUpdate={handleUpdateFilterValue('counterpartyTraderId', FilterOperation.EQUALS)}
      disabled={!isAdmin}
    />
  )
}
